import { SiteConfig } from '@sorpetaler/ui/src/context/SiteConfigContext';

// US site configuration, injected into @sorpetaler/ui via SiteConfigProvider
// (see wrap-root-element.tsx). Placeholder brand values — replace once the US
// entity/contact details and Contentful content are finalized (see the
// `us-content` plan todo).
export const usSiteConfig: SiteConfig = {
  locale: 'Us',
  baseUrl: 'https://www.sorpetaler.com',
  brand: {
    legalName: 'Sorpetaler USA',
    socialLinks: [
      { title: 'LinkedIn', url: 'https://www.linkedin.com/company/sorpetaler-usa' },
      { title: 'Instagram', url: 'https://www.instagram.com/sorpetaler.usa/' },
    ],
  },
  metricaUrl: '',
  breadcrumbLabels: {
    windows: 'Windows',
    doors: 'Doors',
  },
  routePrefix: () => '/',
  categorySlugs: {
    references: [],
    fuerProfis: [],
  },
};
